import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createSlots as _createSlots, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-row ss-contorno ss-bg-clean" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Permissões")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Categoria")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna ss-alinhar-centro" }, "Remover")
], -1)
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_19 = {
  href: "#",
  class: "handle"
}
const _hoisted_20 = { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }
const _hoisted_21 = { class: "ant-col ant-col-xs-18 ant-col-xl-8" }
const _hoisted_22 = { class: "ant-col ant-col-xs-18 ant-col-xl-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_27 = { class: "ant-row ss-contorno ss-bg-clean" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Autorizações")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Categoria")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna ss-alinhar-centro" }, "Remover")
], -1)
const _hoisted_32 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_34 = {
  href: "#",
  class: "handle"
}
const _hoisted_35 = { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }
const _hoisted_36 = { class: "ant-col ant-col-xs-18 ant-col-xl-8" }
const _hoisted_37 = { class: "ant-col ant-col-xs-18 ant-col-xl-3" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_42 = { class: "ant-row ss-contorno ss-bg-clean" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Widgets")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Categoria")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna ss-alinhar-centro" }, "Remover")
], -1)
const _hoisted_47 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_49 = {
  href: "#",
  class: "handle"
}
const _hoisted_50 = { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }
const _hoisted_51 = { class: "ant-col ant-col-xs-18 ant-col-xl-8" }
const _hoisted_52 = { class: "ant-col ant-col-xs-18 ant-col-xl-3" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "ant-row" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_57 = { class: "ant-row ss-contorno ss-bg-clean" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-1" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Relatórios")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna" }, "Categoria")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-coluna ss-alinhar-centro" }, "Remover")
], -1)
const _hoisted_62 = [
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_64 = {
  href: "#",
  class: "handle"
}
const _hoisted_65 = { class: "ant-col ant-col-xs-18 ant-col-xl-12 ss-apresentar-inicio" }
const _hoisted_66 = { class: "ant-col ant-col-xs-18 ant-col-xl-8" }
const _hoisted_67 = { class: "ant-col ant-col-xs-18 ant-col-xl-3" }
const _hoisted_68 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_identificador_modulo = _resolveComponent("selecionar-identificador-modulo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 800
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Módulos "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.modulo.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.modulo.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                    || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_form_item, {
                      label: "Identificador",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_identificador_modulo, {
                          codigoSelecionado: _ctx.state.modulo.identificador,
                          "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.modulo.identificador) = $event))
                        }, null, 8, ["codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Título",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.modulo.titulo) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.atualizarObjetoPrincipal = true))
                        }, null, 544), [
                          [_vModelText, _ctx.state.modulo.titulo]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("textarea", {
                          rows: 5,
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.modulo.descricao) = $event)),
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.atualizarObjetoPrincipal = true))
                        }, null, 544), [
                          [_vModelText, _ctx.state.modulo.descricao]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_tabs, {
                      onTabClick: _ctx.limparPesquisa,
                      activeKey: _ctx.state.abaAtiva,
                      "onUpdate:activeKey": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.abaAtiva) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "Permissões"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoPermissao,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.codigoPermissao) = $event)),
                                  "show-search": "",
                                  allowClear: true,
                                  placeholder: "Digite para selecionar uma permissão",
                                  style: {"width":"100%"},
                                  "filter-option": false,
                                  "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                  options: _ctx.state.listaPermissoes,
                                  onSearch: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pesquisarPermissao($event,_ctx.ETipoPermissao.Dados)))
                                }, _createSlots({ _: 2 }, [
                                  (_ctx.telaBase.fetching)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_spin, { size: "small" })
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "not-found-content", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("button", {
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.adicionarPermissao(_ctx.ETipoPermissao.Dados, _ctx.state.codigoPermissao))),
                                  type: "button",
                                  class: "ant-btn ant-btn-block ant-btn-primary"
                                }, "Adicionar permissão")
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_17, 512), [
                              [_vShow, _ctx.state.permissoesDadosModulo.length > 0]
                            ]),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.state.permissoesDadosModulo,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.permissoesDadosModulo) = $event)),
                              "item-key": "id",
                              handle: ".handle",
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.atualizarPermissoes = true))
                            }, {
                              item: _withCtx(({element}) => [
                                (_openBlock(), _createElementBlock("div", {
                                  key: element.codigo,
                                  class: "ant-row ss-contorno"
                                }, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("a", _hoisted_19, [
                                      _createVNode(_component_icone, {
                                        style: {"margin-top":"4px","font-size":"16px"},
                                        nome: "draggable"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoCategoriaPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.removerPermissao(_ctx.ETipoPermissao.Dados,element.codigoPermissao)),
                                      class: "excluir ss-alinhar-centro"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_23)
                                  ])
                                ]))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          tab: "Autorizações"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoPermissao,
                                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.codigoPermissao) = $event)),
                                  "show-search": "",
                                  allowClear: true,
                                  placeholder: "Digite para selecionar uma autorização",
                                  style: {"width":"100%"},
                                  "filter-option": false,
                                  "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                  options: _ctx.state.listaPermissoes,
                                  onSearch: _cache[14] || (_cache[14] = ($event: any) => (_ctx.pesquisarPermissao($event,_ctx.ETipoPermissao.Autorizacoes)))
                                }, _createSlots({ _: 2 }, [
                                  (_ctx.telaBase.fetching)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_spin, { size: "small" })
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "not-found-content", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.adicionarPermissao(_ctx.ETipoPermissao.Autorizacoes, _ctx.state.codigoPermissao))),
                                  type: "button",
                                  class: "ant-btn ant-btn-block ant-btn-primary"
                                }, "Adicionar autorização")
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_27, _hoisted_32, 512), [
                              [_vShow, _ctx.state.permissoesAutorizacoesModulo.length > 0]
                            ]),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.state.permissoesAutorizacoesModulo,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.permissoesAutorizacoesModulo) = $event)),
                              "item-key": "id",
                              handle: ".handle",
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.atualizarPermissoes = true))
                            }, {
                              item: _withCtx(({element}) => [
                                (_openBlock(), _createElementBlock("div", {
                                  key: element.codigo,
                                  class: "ant-row ss-contorno"
                                }, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("a", _hoisted_34, [
                                      _createVNode(_component_icone, {
                                        style: {"margin-top":"4px","font-size":"16px"},
                                        nome: "draggable"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoCategoriaPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.removerPermissao(_ctx.ETipoPermissao.Autorizacoes,element.codigoPermissao)),
                                      class: "excluir ss-alinhar-centro"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_38)
                                  ])
                                ]))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "3",
                          tab: "Widgets"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoPermissao,
                                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.codigoPermissao) = $event)),
                                  "show-search": "",
                                  allowClear: true,
                                  placeholder: "Digite para selecionar um widget",
                                  style: {"width":"100%"},
                                  "filter-option": false,
                                  "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                  options: _ctx.state.listaPermissoes,
                                  onSearch: _cache[19] || (_cache[19] = ($event: any) => (_ctx.pesquisarPermissao($event,_ctx.ETipoPermissao.Widgets)))
                                }, _createSlots({ _: 2 }, [
                                  (_ctx.telaBase.fetching)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_spin, { size: "small" })
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "not-found-content", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("button", {
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.adicionarPermissao(_ctx.ETipoPermissao.Widgets, _ctx.state.codigoPermissao))),
                                  type: "button",
                                  class: "ant-btn ant-btn-block ant-btn-primary"
                                }, "Adicionar widget")
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_42, _hoisted_47, 512), [
                              [_vShow, _ctx.state.permissoesWidgetsModulo.length > 0]
                            ]),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.state.permissoesWidgetsModulo,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.permissoesWidgetsModulo) = $event)),
                              "item-key": "id",
                              handle: ".handle",
                              onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.atualizarPermissoes = true))
                            }, {
                              item: _withCtx(({element}) => [
                                (_openBlock(), _createElementBlock("div", {
                                  key: element.codigo,
                                  class: "ant-row ss-contorno"
                                }, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("a", _hoisted_49, [
                                      _createVNode(_component_icone, {
                                        style: {"margin-top":"4px","font-size":"16px"},
                                        nome: "draggable"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoCategoriaPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.removerPermissao(_ctx.ETipoPermissao.Widgets,element.codigoPermissao)),
                                      class: "excluir ss-alinhar-centro"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_53)
                                  ])
                                ]))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "4",
                          tab: "Relatórios"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoPermissao,
                                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.codigoPermissao) = $event)),
                                  "show-search": "",
                                  allowClear: true,
                                  placeholder: "Digite para selecionar um relatório",
                                  style: {"width":"100%"},
                                  "filter-option": false,
                                  "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                  options: _ctx.state.listaPermissoes,
                                  onSearch: _cache[24] || (_cache[24] = ($event: any) => (_ctx.pesquisarPermissao($event,_ctx.ETipoPermissao.Relatorios)))
                                }, _createSlots({ _: 2 }, [
                                  (_ctx.telaBase.fetching)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_spin, { size: "small" })
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "not-found-content", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("button", {
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.adicionarPermissao(_ctx.ETipoPermissao.Relatorios, _ctx.state.codigoPermissao))),
                                  type: "button",
                                  class: "ant-btn ant-btn-block ant-btn-primary"
                                }, "Adicionar relatório")
                              ])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_57, _hoisted_62, 512), [
                              [_vShow, _ctx.state.permissoesRelatoriosModulo.length > 0]
                            ]),
                            _createVNode(_component_draggable, {
                              modelValue: _ctx.state.permissoesRelatoriosModulo,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.permissoesRelatoriosModulo) = $event)),
                              "item-key": "id",
                              handle: ".handle",
                              onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.atualizarPermissoes = true))
                            }, {
                              item: _withCtx(({element}) => [
                                (_openBlock(), _createElementBlock("div", {
                                  key: element.codigo,
                                  class: "ant-row ss-contorno"
                                }, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("a", _hoisted_64, [
                                      _createVNode(_component_icone, {
                                        style: {"margin-top":"4px","font-size":"16px"},
                                        nome: "draggable"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("span", null, _toDisplayString(element.descricaoCategoriaPermissao), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.removerPermissao(_ctx.ETipoPermissao.Relatorios,element.codigoPermissao)),
                                      class: "excluir ss-alinhar-centro"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_68)
                                  ])
                                ]))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onTabClick", "activeKey"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}